module.exports = __webpack_public_path__ + "static/media/hh.88a7d514.svg";